/**
 *
 * Asynchronously loads the component for MarkAttendancePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MarkAttendancePage = lazyLoad(
  () => import('./index'),
  module => module.MarkAttendancePage,
);
